// extracted by mini-css-extract-plugin
export var iframe = "next-departures-module-module--iframe--a47da";
export var nextDeparturesModule = "next-departures-module-module--nextDeparturesModule--afb69";